module.exports = __webpack_public_path__ + "static/media/zvony1.b030540a.jpg";